import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/service/api-service/api-service';

@Injectable({ providedIn: 'root' })
export class TagsService {
  constructor(private api: ApiService) {}

  getTags(module: string): Observable<any> {
    const params = new HttpParams().set('module', module);
    return this.api.get('/api/tags', params);
  }

  createTag(module: string, label: string): Observable<any> {
    return this.api.post('/api/tags', { tag_module: module, tag_label: label });
  }
}
